export enum VesselStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
